import classnames from 'classnames';
import React from 'react';

import { PopupBuilderRichTextContentSection } from '../contentTypes';
import { Div } from '../HTMLElement';
import { TextAlign } from '../interfaces';
import { formatHtml } from '../util';
import { PropsWithCustomComponent, VariantsController } from '../VariantsController';

export interface PopupBuilderRichTextComponentProps extends PopupBuilderRichTextContentSection {}

const PopupBuilderRichTextComponent = ({ options, richText }: PopupBuilderRichTextComponentProps) => {
  const textAlign = options?.textAlign as TextAlign;

  return (
    <React.Fragment>
      {options?.enabled && (
        <Div className={classnames('popup-builder-rich-text-component', options.classes)} textAlign={textAlign}>
          {formatHtml(richText)}
        </Div>
      )}
    </React.Fragment>
  );
};

export type PopupBuilderRichTextComponentVariants = '';

const PopupBuilderRichTextComponentController = (
  props: PropsWithCustomComponent<PopupBuilderRichTextComponentProps>
) => (
  <VariantsController<PopupBuilderRichTextComponentProps, PopupBuilderRichTextComponentVariants>
    {...props}
    variantsControllerConfig={{
      defaultComponent: PopupBuilderRichTextComponent,
      name: 'PopupBuilderRichTextComponent',
    }}
  />
);
export { PopupBuilderRichTextComponentController as PopupBuilderRichTextComponent };
